import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { pushSupported, getPushPermission, subscribePush, unsubscribePush } from "@/lib/push";

export default function PushBell() {
  const [state, setState] = useState("checking"); // unsupported | denied | default | granted | checking
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      if (!pushSupported()) { setState("unsupported"); return; }
      const perm = await getPushPermission();
      setState(perm);
    })();
  }, []);

  if (state === "unsupported" || state === "checking") return null;

  const isOn = state === "granted";

  const toggle = async () => {
    setBusy(true);
    try {
      if (isOn) { await unsubscribePush(); setState("default"); }
      else { await subscribePush(); setState("granted"); }
    } catch (e) {
      window.alert(e?.message || "Push konnte nicht aktiviert werden");
    } finally { setBusy(false); }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid="push-bell-toggle"
      title={isOn ? "Push-Benachrichtigungen aktiv — Klick zum Deaktivieren" : "Push-Benachrichtigungen aktivieren"}
      className={`p-2 rounded-sm border transition-colors ${
        isOn
          ? "border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10"
          : "border-[var(--border-strong)] text-[var(--text-2)] hover:text-[var(--text)] hover:border-[var(--border-strong)]"
      }`}
    >
      {isOn ? <Bell size={16} strokeWidth={1.7} /> : <BellOff size={16} strokeWidth={1.7} />}
    </button>
  );
}
